'use client';

import ShopDetailIntroduce from '@/components/shop/shop-detail-introduce';
import ShopDetailPromotion from '@/components/shop/shop-detail-promotion';
import useLogEvents from '@/lib/client-hook/use-log-events';
import { convertLanguageName } from '@/lib/convert-language-code';
import { Languages } from '@/lib/dictionaries';
import { isDonationShop } from '@/lib/shipping-fee';
import { IShop } from '@/schema/shop';
import React, { useState } from 'react';

import classes from './shop-detail-home.module.scss';

enum ShopDetailTabName {
  Intro = 'DETAIL',
  Promotion = 'EVENT',
}

function ShopDetailTab({ lang, shop }: { lang: Languages; shop: IShop }) {
  const [tabName, setTabName] = useState(ShopDetailTabName.Intro);

  const { logShareEvent } = useLogEvents();

  const handleChangeTab = (newTabName: ShopDetailTabName) => {
    logShareEvent('bnb_shop_detail_tab', {
      state: newTabName,
    });
    setTabName(newTabName);
  };

  return (
    <>
      <div className={classes.detailTabsList}>
        <article className={`${classes.tabsListLayout1} ${classes.th}`}>
          <div className={classes.tabsList}>
            <ul>
              <li>
                <button
                  className={`${classes.tabsBtn} ${tabName === ShopDetailTabName.Intro && classes.active}`}
                  onClick={() => handleChangeTab(ShopDetailTabName.Intro)}
                >
                  DETAIL
                </button>
              </li>
              {!isDonationShop(shop.category) && shop.missions.length > 0 && (
                <li>
                  <button
                    className={`${classes.tabsBtn} ${tabName === ShopDetailTabName.Promotion && classes.active}`}
                    onClick={() => handleChangeTab(ShopDetailTabName.Promotion)}
                  >
                    GIFTIFAN EVENT
                  </button>
                </li>
              )}
            </ul>
          </div>
        </article>
      </div>
      <div className={classes.detailTabsGroup}>
        <div className={classes.tabsBox}>
          {tabName === ShopDetailTabName.Intro && (
            <ShopDetailIntroduce
              lang={lang}
              title={shop.title[lang]}
              images={shop.images[lang]}
              usageChartImage={shop.usageChartImage}
              commonImages={shop.commonImages}
              productNoticeImages={shop.productNoticeImages}
            />
          )}
          {tabName === ShopDetailTabName.Promotion && (
            <ShopDetailPromotion missionImages={shop.missionImages} />
          )}
        </div>
      </div>
    </>
  );
}

export default ShopDetailTab;
